import styled from "styled-components";

export const FormTitle = styled.h1`
  font-family: "Hind", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 46px;
  line-height: 52px;
  color: #000000;
  letter-spacing: 0.01em;
`;

export const SectionLabel = styled.div``;
